/**
 * Выпадающий список (с вариантами сортировки)
 */
class Dropdown {

  /**
   * 
   * @param {String} selector Селектор элемента
   */
  constructor() {
    this.dropdown = document.querySelector('.dropdown');
    this.dropdownValue = document.querySelector('.dropdown__value');
    this.init();
  }

  static existsOnPage() {
    return (document.querySelector(".dropdown") !== null);
  }

  init() {
    // управляет показом/сокрытием выпадающего списка с вариантами сортировки при клике по текущему выбранному значению
    this.dropdownValue.addEventListener('click', () => this.toggle());
    
    // закрывает открытый выпадающий список при клике за его пределами
    document.addEventListener('click', (e) => {
      // предварительно проверяем, не пришел ли клик из самого выпадающего списка
      if (!this.dropdown.contains(e.target) && this.isOpened()) {
        this.close();
      }
    })
  }

  /**
   * Переключает видимость выпадающего списка
   */
  toggle() {
    this.dropdown.classList.toggle("dropdown--opened");
  }

  /**
   * Закрывает выпадающий список
   */
  close() {
    this.dropdown.classList.remove("dropdown--opened");
  }

  /**
   * Возвращает true, если выпадающий список открыт
   */
  isOpened() {
    return this.dropdown.classList.contains("dropdown--opened");
  }
}

export default Dropdown;